import { render, staticRenderFns } from "./select-component.vue?vue&type=template&id=67d20d49&scoped=true&"
import script from "./select-component.vue?vue&type=script&lang=js&"
export * from "./select-component.vue?vue&type=script&lang=js&"
import style0 from "./select-component.vue?vue&type=style&index=0&id=67d20d49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d20d49",
  null
  
)

export default component.exports